module.exports = __webpack_public_path__ + "static/media/fundo_goiania_armadilhaDisseminadoraInseticida.f3446904.png";